<template>
<div>
    <div>
        <div class="formcssformat col-md-12">
            <form @submit.prevent>
              <div class="formatcaninfo"><h2>Candidate Information</h2></div>
              <div class="mb-3">
                <label class="lblformat">FIRST NAME:<span class="starred">*</span></label>
                <input type="text" name="firstName" v-model="firstName" class="form-control form-control-sm formattxt"  id="exampleInputPassword1">
              </div>
              <div class="mb-3">
                <label class="lblformat">LAST NAME:<span class="starred">*</span></label>
                <input type="text" name="lastName" v-model="lastName" class="form-control form-control-sm formattxt"  id="exampleInputPassword1">
              </div>
              <div class="mb-3">
                <label class="lblformat">E-MAIL:<span class="starred">*</span></label>
                <input type="email" name="email" v-model="email" class="form-control formattxt" id="exampleFormControlInput1" placeholder="name@example.com">
              </div>
              <div class="mb-3">
                <label class="lblformat">SELECT A REGION: <span class="starred">*</span> </label>
                <select @change="handleChange" v-model="selected" name="select" class="form-select form-select-sm formattxt" aria-label=".form-select-sm example">
                  <option selected>Open this select menu</option>
                  <option v-for="erg in getregions" v-bind:value="{ id: erg.jobrgid, text: erg.country }">{{erg.country}}</option>

                </select>
                
              </div>
              <div class="mb-3">
                <!-- <label for="formFileSm" class="form-label">Small file input example</label>
                <input class="form-control form-control-sm" id="formFileSm" type="file"> -->
                
              </div>
              <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label lblformat">MESSAGE: <span class="starred">*</span> </label>
                <textarea class="form-control formattxt" name="coverletter" v-model="coverletter" id="exampleFormControlTextarea1" rows="3"></textarea>
              </div>
   
              <div class="progress" style="margin-top: 40px;" >
                <progress max="100" :value.prop="uploadPercentage" class="progresscss"></progress>
                </div>
                <div class="mb-3">
                    <label for="formFileSm" class="form-label lblformat">SELECT A FILE: <span class="starred">*</span> </label>
                    <input class="form-control form-control-sm file formattxt" ref="fileInput" id="formFileSm" type="file" multiple @change="onFileSelect">
                </div>
             
  
              <div class="mb-3 form-check" style="margin-top: 10px;">
                <div class="lblformat" style="margin-top: 50px;" >
                  <span class="lblformat"> <span class="starred">*</span>Check to accept our recruitment policy</span>
                  <input type="checkbox"  v-model="eulachecked" name="EULA" class="form-check-input " id="exampleCheck1">
                </div>
              </div>
              <button type="submit"  style="margin-top: 50px;" class="btn btn-primary" @click="UploadAllFiles()">Submit</button>
            </form>
          </div>
        
    </div>
   
    
</div>
</template>

<script>
import axios from 'axios';
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from 'vue-router'
  
  const router = useRouter()
  const route = useRoute()

export default{
props: ['myjobid', 'pdflink'],
data(){
    return {
        images: [],
        isDragging: false,
        filenames: [],
        firstName: '',
        lastName: '',
        email: '',
        coverletter: '',
        jobpdf: '',
        jobrefid: this.$route.params.jobid,
        getregions: [],
        selected: '',
        selectedid: 0,
        file: '',
        getjobnumber: '',
        uploadPercentage: 0,
        eulachecked: false,
        getEmail: '',
        getRefId: '',
        getFirstName: '',


       
    }
},
methods: {
  selectFiles() {
                this.$refs.fileInput.click();
            },
     handleChange(){
        let selectedid = this.selected.id
        this.selectedid = selectedid
    },
  
            onFileSelect(event) {
                event.preventDefault
                this.file =  this.$refs.fileInput.files[0];
                if(this.file.length === 0) return;
            },
     
    
  async UploadAllFiles() {
    await axios.get(`getallSingleCareer/${this.jobrefid}`).then(
        response => {
            this.getEmail = response.data[0].jobapemail
            this.getRefId = response.data[0].jobrefid
          })
          .catch((error) => {
              console.log(error)
        })  
    if(this.firstName === '') {
      let e = "First name is required."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    } 
    else if(this.lastName === '') {
      let e = "Last name is required."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if(this.email === '') {
      let e = "Email is required."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if(this.coverletter === '') {
      let e = "We help you standout. Please add a message to highlight key points on your resume."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if( this.jobrefid === '') {
      let e = "Job region is required."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if( this.file === '') {
      let e = "Please upload a resume"
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if( this.eulachecked === false) {
      let e = "Please acknowledge and accept recruitment clauses."
      const toast = useToast();
      toast.error(e, {
      timeout: 6000
        });
      return;
    }
    else if(this.getEmail === this.email && this.getEmail === this.email) {
          let e = "You already applied for this job. Dual submission is not acceptable."
              const toast = useToast();
              toast.error(e, {
              timeout: 6000
              });
          return;
        }
    else {
       
    this.file = this.$refs.fileInput.files[0];
    let formData = new FormData()
    formData.append("jobapfirstname", this.firstName)
    formData.append("jobaplastname", this.lastName)
    formData.append("jobapemail", this.email)
    formData.append("jobapmessage", this.coverletter)
    formData.append("jobpdf", this.file)
    formData.append("jobrefid", this.jobrefid)
    formData.append("jobregion", this.selectedid)
    
    //set the form headers
    let axiosConfig = {
        headers: {
        'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
      }.bind(this)
        }
    //send the data to backend using the api link          
    axios.post('getallcareerapplication/', formData, axiosConfig).then(response => {
                if (response.status === 201) {
                  let e = "Record posted successfully."
                  const toast = useToast();
                  toast.success(e, {
                  timeout: 6000
                  });
                }
            })
            .catch(e => {
            const toast = useToast();
            toast.error(e, {
            timeout: 6000,
            });
        })
        formData = ''
        this.file = ''
        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.coverletter = ''
        this.jobpdf = ''
        this.$refs.fileInput.value = null
        this.uploadPercentage = 0
    }
  }
    
  },
async mounted() {
    //------------breadcrumbs mappings info---------------
  await axios.get('getallcareerallregions/').then(
  response => {
      this.getregions = response.data
    })
    .catch((error) => {
        console.log(error)
        })   
    
}

}
</script>
<style scoped>
/*@import "https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css";*/
.progresscss {
  width: 100%;
}
.formatcaninfo {
  padding: 20px;
  font-weight: bold;
  font-size: 40;
  color: orangered;
  text-align: center;
}
.lblformat {
  margin-top: 16px;
  width: 100%;
  color: #003;
  padding: 10px;
  font-weight: bold;
}
.form-check-input {
  width: 30px;
  height: 30px;
}
.starred {
  color: orangered;
  font-size: 20px;
}
.formattxt {
  background-color: rgb(245, 245, 240);
}

</style>